import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadPublicFlags } from '../lib/publicFlags';
import { NEW_BRAND, brandColor } from '../lib/brand';

// "miD" keeps its case inside uppercase titles (DESIGN.md). Off, the text stays one plain string.
const brandName = (text) => (NEW_BRAND
  ? text.split('miD').flatMap((part, i) => (i ? [<span key={i} className="brand-name">miD</span>, part] : [part]))
  : text);
import './landing_mid.css';
import { applyLandingMetadata } from './landing/landingSeo';
import { landingFaq } from './landing/landingFaq';

export default function LandingMiD() {
  // G-05: the identity promise follows the buyer profile switch.
  const [buyerProfileV2, setBuyerProfileV2] = useState(false);
  useEffect(() => {
    let mounted = true;
    loadPublicFlags().then((flags) => { if (mounted) setBuyerProfileV2(flags.buyer_profile_v2); });
    return () => { mounted = false; };
  }, []);
  useEffect(() => applyLandingMetadata('/sobre'), []);
  return (
    <div className="lp-new" data-testid="landing-mid">
      {/* =========================== NAV =========================== */}
      <nav className="lp-nav-v2" data-testid="lp-nav">
        <div className="nav-in">
          <Link to="/" className="mark" aria-label="miD">
            m<i>i</i><b>D</b>.
          </Link>
          <div className="nav-links">
            <a href="#processo">Como funciona</a>
            <a href="#ferramentas">Ferramentas</a>
            <a href="#agentes">Para agentes</a>
          </div>
          <Link to="/comecar" className="btn btn-p" data-testid="lp-nav-cta">
            Criar o meu Buyer DNA
          </Link>
        </div>
      </nav>

      {/* =========================== HERO ========================== */}
      <header className="hero" data-testid="lp-hero">
        <div
          className="glow"
          style={{ width: 640, height: 640, background: 'var(--brand-primary, #4B2E8C)', opacity: 0.45, left: -200, top: -220 }}
        />
        <div
          className="glow"
          style={{ width: 560, height: 560, background: 'var(--brand-good-text, #0E6B60)', opacity: 0.38, right: -180, bottom: -200 }}
        />
        <div className="wrap hero-grid">
          <div>
            <span className="eyebrow">Mediador Imobiliário Digital</span>
            <h1 className="ask">
              Comprar casa começa por saber <em>o que procuras.</em>
            </h1>
            <p className="lead">
              É a pergunta que os agentes vão começar a fazer. Ter miD quer dizer que sabes o que
              procuras, que tens uma solução de crédito e que a tua próxima visita não é um tiro no escuro.
            </p>
            <div className="cta">
              <Link to="/comecar" className="btn btn-p" data-testid="lp-hero-cta-buyer">
                Criar o meu Buyer DNA &rarr;
              </Link>
              <a href="#agentes" className="btn btn-g" data-testid="lp-hero-cta-agent">
                Sou agente
              </a>
            </div>
            <small>Gratuito para compradores &middot; Começa sem criar conta</small>
          </div>

          {/* signature: the credential card */}
          <div className="card-id" data-testid="lp-hero-credential">
            <div className="top">
              <span className="eyebrow" style={{ color: 'var(--brand-line, #8F91AC)' }}>Exemplo ilustrativo</span>
              <span className="stat">BUYER DNA</span>
            </div>
            <h2>
              O <span>Construtor</span>
              <br />
              de Raízes
            </h2>
            <p className="who">T2 &middot; até 300 000 &euro; &middot; Lisboa, Odivelas, Loures</p>
            <div className="rows">
              <div className="row">
                <span className="tick">&#10003;</span>
                <span className="k">Buyer DNA</span>
                <span className="v">NITIDEZ 82%</span>
              </div>
              <div className="row">
                <span className="tick">&#10003;</span>
                <span className="k">Com solução de crédito</span>
                <span className="v">INTERMEDIÁRIO</span>
              </div>
              <div className="row">
                <span className="tick">&#10003;</span>
                <span className="k">Buyer Readiness Score</span>
                <span className="v">100 / 100</span>
              </div>
            </div>
            <div className="card-foot">
              <span>EXEMPLO DE BUYER DNA</span>
              <span>SCORE ILUSTRATIVO</span>
            </div>
          </div>
        </div>
      </header>

      {/* ========================= PROBLEMA ========================= */}
      <section id="problema" data-testid="lp-problema">
        <div className="wrap">
          <span className="eyebrow">O problema</span>
          <h2>
            Preço e tipologia<br />são só <span className="p">o início.</span>
          </h2>
          <p className="sub">
            A tua rotina, as zonas onde queres viver e aquilo de que não abdicas também contam.
            O Buyer DNA organiza essas prioridades antes de analisares anúncios.
          </p>
          <div className="duo">
            <div className="tile a">
              <span className="eyebrow" style={{ color: 'var(--teal-deep)' }}>A oferta</span>
              <div className="big">O anúncio</div>
              <p>Preço, tipologia, área e localização.</p>
            </div>
            <div className="tile b">
              <span className="eyebrow">A procura</span>
              <div className="big">O Buyer DNA</div>
              <p>Orçamento, rotina, zonas e prioridades.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ========================= ROADMAP ========================= */}
      <section id="processo" style={{ background: 'var(--brand-surface-2, #F3F1EC)', paddingTop: 88 }} data-testid="lp-roadmap">
        <div className="wrap">
          <span className="eyebrow">O percurso</span>
          <h2>
            Da primeira ideia<br />à <span className="p">próxima visita.</span>
          </h2>
          <p className="sub">
            Comprar casa tem várias fases. O Buyer Readiness Score ajuda-te a perceber
            o teu nível de preparação e os próximos passos.
          </p>

          <div className="road">
            <span className="eyebrow">Exemplo do percurso de compra</span>
            <div className="track" style={{ marginTop: 22 }}>
              <div className="step on"><div className="b" /><div className="l">DEFINE</div></div>
              <div className="step on"><div className="b" /><div className="l">ORIENTA</div></div>
              <div className="step on"><div className="b" /><div className="l">PROVA</div></div>
              <div className="step"><div className="b" /><div className="l">PROCURA</div></div>
              <div className="step goal">
                <div className="b" style={{ background: 'var(--brand-line, #E7E4DE)' }} />
                <div className="l" style={{ color: 'var(--brand-muted, #9B9CAE)' }}>DECIDE</div>
              </div>
            </div>
            <div className="road-foot">
              <p>
                Começa pelo <b>Buyer DNA.</b> Depois podes pedir contacto a um intermediário de crédito.
              </p>
              <Link to="/comecar" className="btn btn-o" data-testid="lp-roadmap-cta">
                Ver o meu Buyer Readiness Score
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ========================= FERRAMENTAS ========================= */}
      <section id="ferramentas" data-testid="lp-ferramentas">
        <div className="wrap">
          <span className="eyebrow">O que fazes aqui</span>
          <h2>
            Define o que procuras.<br />Prepara a compra.
          </h2>
          <div className="tools">
            <div className="tool">
              <span className="n">01 &middot; BUYER DNA</span>
              <h3>Quem és como comprador</h3>
              <p>
                Organiza as tuas preferências, prioridades e escolhas numa conversa.
                Define as zonas, a rotina e aquilo de que não abdicas.
              </p>
              <div className="bar"><i style={{ width: '82%', background: 'var(--purple)' }} /></div>
            </div>
            <div className="tool">
              <span className="n">02 &middot; MATCHMAKER</span>
              <h3>Se aquele anúncio te serve</h3>
              <p>
                Cola o link de um anúncio de um portal suportado. Compara a casa com o teu
                Buyer DNA e vê os pontos fortes, os conflitos e a informação em falta.
              </p>
              <div className="bar"><i style={{ width: '88%', background: 'var(--teal)' }} /></div>
            </div>
            <div className="tool">
              <span className="n">03 · Buyer Readiness Score</span>
              <h3>O próximo passo da compra</h3>
              <p>
                Consulta o teu Buyer Readiness Score e os passos para preparar a compra.
                O score informa a tua preparação; não é uma aprovação de crédito.
              </p>
              <div className="bar">
                <i style={{ width: '72%', background: 'linear-gradient(90deg,var(--purple),var(--teal))' }} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========================= AGENTES ========================= */}
      <section id="agentes" className="dark" data-testid="lp-agentes">
        <div className="wrap split">
          <div>
            <span className="eyebrow">Para agentes</span>
            <h2>
              Conhece a procura<br /><span className="p">nas tuas zonas.</span>
            </h2>
            <p className="sub">
              Consulta o Buyer DNA dos compradores, o orçamento, as zonas e a fase de preparação.
              Compara essa procura com os teus imóveis antes de propor uma visita.
            </p>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 34 }}>
              <Link to="/precos-agentes" className="btn btn-p" data-testid="lp-agent-cta">
                Ver planos para agentes
              </Link>
            </div>
          </div>
          <div>
            <p className="example-label">Exemplos ilustrativos de compradores</p>
            {[
              { who: '3 adultos, 1 criança, com pets', typo: 'T4', budget: '350 k€', zones: 'LISBOA · ODIVELAS · LOURES · BUYER DNA' },
              { who: 'Casal, com pets', typo: 'T2', budget: '300 k€', zones: 'LISBOA · ODIVELAS · BUYER DNA' },
              { who: 'Casal', typo: 'T2', budget: '250 k€', zones: 'ODIVELAS · LOURES · BUYER DNA' },
            ].map((b, i) => (
              <div className="lock" key={i}>
                <div className="pad">
                  <svg width="20" height="22" viewBox="0 0 24 28" fill="none" stroke={brandColor('line', '#A9AAC2')} strokeWidth="2.4">
                    <rect x="3" y="12" width="18" height="14" rx="3" />
                    <path d="M7 12V8a5 5 0 0 1 10 0v4" />
                  </svg>
                </div>
                <div>
                  <div className="who">
                    {b.who} &nbsp;|&nbsp; {b.typo} &nbsp;|&nbsp; <span>{b.budget}</span>
                  </div>
                  <div className="zone">{b.zones}</div>
                </div>
              </div>
            ))}
            <p
              style={{
                fontFamily: 'var(--mono)', fontSize: '.72rem', letterSpacing: '.14em',
                color: 'var(--brand-line, #B9BACB)', marginTop: 20,
              }}
            >
              {buyerProfileV2 ? 'VÊS O PRIMEIRO NOME E A FOTOGRAFIA. EMAIL E TELEFONE NUNCA SÃO PARTILHADOS.' : 'VÊS O BUYER DNA. NÃO VÊS QUEM SÃO — ATÉ HAVER MATCH.'}
            </p>
          </div>
        </div>
      </section>

      <section id="perguntas" className="lp-faq">
        <div className="wrap">
          <h2>{brandName('Perguntas sobre comprar casa com o miD')}</h2>
          {landingFaq.map(({ question, answer }) => (
            <details key={question}><summary>{question}</summary><p>{answer}</p></details>
          ))}
        </div>
      </section>

      {/* ========================= FECHO ========================= */}
      <section
        id="final"
        className="dark close-sec"
        style={{ position: 'relative', overflow: 'hidden', padding: '120px 0' }}
        data-testid="lp-final"
      >
        <div
          className="glow"
          style={{ width: 720, height: 720, background: 'var(--brand-primary, #4B2E8C)', opacity: 0.42, left: '50%', marginLeft: -360, top: 20 }}
        />
        <div className="wrap" style={{ position: 'relative' }}>
          <h2 className="ask2">
            Primeiro o plano.<br />Depois as visitas.
          </h2>
          <p className="sub" style={{ margin: '26px auto 0', textAlign: 'center' }}>
            Cria o teu Buyer DNA e usa-o para analisar anúncios e preparar a compra. Gratuito para compradores.
          </p>
          <div
            style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', marginTop: 38 }}
          >
            <Link to="/comecar" className="btn btn-p" data-testid="lp-final-cta-buyer">
              Criar o meu Buyer DNA
            </Link>
            <Link to="/register?type=agent" className="btn btn-g" data-testid="lp-final-cta-agent">
              Sou agente
            </Link>
          </div>

          {/* Preserve intermediary registration entry point */}
          <p className="interm-line" data-testid="lp-interm-line">
            És intermediário de crédito?
            <Link to="/register-credit-intermediary" data-testid="lp-interm-register">
              Regista-te aqui &rarr;
            </Link>
          </p>
        </div>
      </section>

      {/* ========================= FOOTER ========================= */}
      <footer className="lp-foot-v2" data-testid="lp-footer">
        <div className="wrap foot-in">
          <div>© {new Date().getFullYear()} miD · mediadorimobiliariodigital.com</div>
          <nav className="foot-links" aria-label="Links de rodapé">
            <Link to="/terms">TERMOS</Link>
            <Link to="/privacy">PRIVACIDADE</Link>
            <Link to="/cookies">COOKIES</Link>
            <Link to="/intermediary/login" data-testid="lp-foot-interm-login">INTERMEDIÁRIOS</Link>
            <Link to="/register-credit-intermediary">REGISTAR INTERMEDIÁRIO</Link>
            <a href="mailto:geral@mediadorimobiliariodigital.com">CONTACTO</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
